(() => {
  function initialize(root) {
    if (root.dataset.qhInitialized) return;
    const dataElement = root.querySelector('[data-qh-product-data]');
    if (!dataElement) return;
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch { return; }
    if (!Array.isArray(data.variants) || !data.variants.length) return;
    root.dataset.qhInitialized = 'true';
    const get = selector => root.querySelector(selector);
    const variantInput = get('[data-qh-variant-id]');
    const form = variantInput.form;
    const quantity = form.elements.quantity;
    const dialog = get('[data-qh-image-dialog]');
    const mainImage = get('[data-qh-main-image]');
    const variants = new Map(data.variants.map(variant => [String(variant.id), variant]));
    let selected = variants.get(String(data.selectedId)) || data.variants[0];
    let imageIndex = 0;

    function images() { return [...new Set(selected.images.filter(Boolean))]; }
    function showImage(index) {
      const sources = images();
      imageIndex = Math.max(0, Math.min(index, sources.length - 1));
      if (sources.length) mainImage.src = sources[imageIndex];
      mainImage.alt = `${data.name} — ${selected.label}`;
      root.querySelectorAll('[data-qh-image]').forEach(button => {
        const active = Number(button.dataset.qhImage) === imageIndex;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
    function productURL(variant) {
      const target = new URL(variant.url, window.location.origin);
      if (target.origin !== window.location.origin) return null;
      const result = new URL(window.location.href);
      result.pathname = target.pathname;
      result.searchParams.set('variant', variant.id);
      return result;
    }
    function chooseVariant(id, updateURL = false) {
      const variant = variants.get(String(id));
      if (!variant) return;
      selected = variant;
      variantInput.value = variant.id;
      const productInput = form.querySelector('[name="product-id"]');
      if (productInput) productInput.value = variant.productId;
      get('[data-qh-price]').textContent = variant.price;
      for (const selector of ['[data-qh-variant-name]', '[data-qh-variant-detail]']) {
        const element = get(selector);
        if (element) element.textContent = variant.label;
      }
      const availability = get('[data-qh-availability]');
      availability.textContent = variant.available ? data.availableText : data.unavailableText;
      availability.classList.toggle('unavailable', !variant.available);
      get('[data-qh-add]').disabled = !variant.available;
      root.querySelectorAll('[data-qh-variant]').forEach(link => {
        const active = link.dataset.qhVariant === String(variant.id);
        link.classList.toggle('selected', active);
        if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        const url = productURL(variants.get(link.dataset.qhVariant));
        if (url) link.href = url.href;
      });
      const thumbnails = get('[data-qh-thumbnails]');
      thumbnails.replaceChildren();
      images().forEach((source, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'thumb';
        button.dataset.qhImage = String(index);
        button.setAttribute('aria-label', data.imageLabels[index] || data.imageLabels[0]);
        const image = document.createElement('img');
        image.src = source;
        image.alt = '';
        image.width = 54;
        image.height = 61;
        button.append(image);
        thumbnails.append(button);
      });
      const detailImage = get('[data-qh-detail-image]');
      if (images().length) detailImage.src = images()[1] || images()[0];
      detailImage.alt = `${data.name} — ${variant.label}`;
      showImage(0);
      if (updateURL) {
        const url = productURL(variant);
        if (url) history.pushState(null, '', url);
      }
    }
    function clampQuantity() {
      const value = Math.trunc(Number(quantity.value));
      quantity.value = String(Math.max(1, Math.min(99, Number.isFinite(value) ? value : 1)));
    }
    root.addEventListener('click', event => {
      const variantLink = event.target.closest('[data-qh-variant]');
      if (variantLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        chooseVariant(variantLink.dataset.qhVariant, true);
      }
      const thumb = event.target.closest('[data-qh-image]');
      if (thumb) showImage(Number(thumb.dataset.qhImage));
      const step = event.target.closest('[data-qh-quantity-step]');
      if (step) { clampQuantity(); quantity.value = String(Number(quantity.value) + Number(step.dataset.qhQuantityStep)); clampQuantity(); }
      if (event.target.closest('[data-qh-zoom]')) {
        const expanded = get('[data-qh-expanded-image]');
        expanded.src = mainImage.src;
        expanded.alt = mainImage.alt;
        if (!dialog.open) dialog.showModal();
      }
      if (event.target.closest('[data-qh-close-image]') || event.target === dialog) dialog.close();
    });
    quantity.addEventListener('change', clampQuantity);
    form.addEventListener('submit', event => {
      clampQuantity();
      if (!selected.available || variantInput.value !== String(selected.id)) event.preventDefault();
    });
    window.addEventListener('popstate', () => {
      if (!root.isConnected) return;
      const id = new URL(window.location.href).searchParams.get('variant');
      chooseVariant(variants.has(id) ? id : data.selectedId);
    });
    chooseVariant(selected.id);
  }
  function initializeAll(scope = document) {
    if (scope.matches?.('[data-qh-product]')) initialize(scope);
    scope.querySelectorAll('[data-qh-product]').forEach(initialize);
  }
  initializeAll();
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
